import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Box, Text } from "@chakra-ui/react";
import _ from "lodash";
import MultiSelect from "react-select";
import { setSelectedBranches } from "../../../../../store/actions/subscriptionsActions";

const BranchSelection = () => {
  const dispatch = useDispatch();
  const { branches, organizationId } = useSelector((store) => store.defaultReducer);
  const [branchesClone, setBranchesClones] = useState(_.cloneDeep(branches).filter((a) => a.organizationId === organizationId && !_.isEmpty(a.reportStatus) && Number(a.reportStatus)  ))

  useEffect(() => {
    const updatedBranches = _.cloneDeep(branches).filter((a) => a.organizationId === organizationId && !_.isEmpty(a.reportStatus) && Number(a.reportStatus))
    setBranchesClones(updatedBranches)
  }, [branches, organizationId]);


  const {
    subscription,
    activeReportTypeId,
    editReportTypeId,
  } = useSelector((store) => store.subscriptionsReducer);

  const subscriptionClone = _.cloneDeep(subscription);
  const index = subscriptionClone?.reports?.findIndex(
    (a) => a.reportTypeId === activeReportTypeId
  );
  let currentBranches = [];
  if (index > -1) {
    currentBranches = subscriptionClone.reports[index].branches;
  }

  return (
    (activeReportTypeId || editReportTypeId) ? (<Box
      mt="10px"
      w="100%"
      h="auto"
      borderRadius="8px"
      border="1px solid #b0b0b0"
      p="12px 5px 9px 12px"
    >
      <Text
        h="15px"
        lineHeight="15px"
        fontSize="12px"
        color="#6a6a6a"
      >
        Select Branches
      </Text>

        <MultiSelect
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              border: "none", outline: "none", boxShadow: "none", paddingLeft: 0, marginLeft: 0,
            }),
          }}
          options={branchesClone.map((a) => ({
            value: a.id,
            label: a.name,
          }))}
          defaultValue={currentBranches?.map((branch) => {
            return {
              value: branch.id,
              label: branchesClone.find((a) => a.id === branch.id).name,
            };
          })}
          onChange={(e) => {
            const newBranches = e.map((a, i) => ({
              id: a.value,
              listOrder: i + 1,
            }));
            dispatch(setSelectedBranches(newBranches));
          }}
          isMulti={true}
          isClearable={true}
          isSearchable={true}
          placeholder="Select Branch"
        />

    </Box>)
    : null
  );
};

export default BranchSelection;
